import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { AdImageBatch } from './useAdImageBatches'

interface UseAdImageBatchByIdParams {
  batch_id: number | string | null
}

export interface AdImageBatchWithApplications extends AdImageBatch {
  applications?: Array<{
    application_id: number
    batch_id: number
    clinic_id?: number
    broadcast_device_id?: number
    applied_by?: number
    applied_at: string
    is_active: boolean
    clinic?: {
      clinic_id: number
      clinic_name: string
      is_active: boolean
      tags?: string[]
    }
    broadcast_device?: {
      broadcast_device_id: number
      name?: string
      is_active: boolean
    }
  }>
}

export function useAdImageBatchById({ batch_id }: UseAdImageBatchByIdParams) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<AdImageBatch>>(
    token && batch_id ? `/api/ad-image-batches/${batch_id}` : null,
    undefined,
    token ?? '',
  )

  return {
    batch: data?.data || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useAdImageBatchApplications({ batch_id }: UseAdImageBatchByIdParams) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<AdImageBatchWithApplications>>(
    token && batch_id ? `/api/ad-image-batches/${batch_id}/applications` : null,
    undefined,
    token ?? '',
  )

  return {
    batch: data?.data || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
